<template>
  <tbody>
    <template v-for="(data, index) in data">
      <tr v-if="data" :key="index" style="text-align: center">
        <td style="text-align: center" :rowspan="data.edge.length + 1">
          {{ data.name }}
        </td>
      </tr>
      <tr
        v-for="(edge, keyRow) in data.edge"
        :key="`${keyRow}-${edge}.${index}`"
        style="text-align: center"
      >
        <td
          v-for="(_, keyCellName) in cellNames"
          :key="keyCellName"
          style="text-align: center"
        >
          {{ getFormatNumber(data[keyCellName][keyRow], '1') }}
        </td>
      </tr>
      <tr :key="`${index}.${data.name}`" v-if="data.name">
        <td style="text-align: center">
          <b
            >{{ $t('common_words.total') }} {{ $t('common_words.allotment') }}
          </b>
        </td>
        <td
          v-for="(operationType, index) in cellNames"
          :key="`${index}.${operationType}`"
          style="text-align: center"
        >
          {{ getFormatNumber(getValueData(data, index, operationType), index) }}
        </td>
      </tr>
    </template>
  </tbody>
</template>
<script>
import { getSumOfValorFromArray } from 'src/util/Util';
import Formatter from 'src/class/Formatter';

export default {
  name: 'tbody-profile-cluster',
  props: {
    data: Array | Object,
    cellNames: {
      type: Object,
    },
  },
  methods: {
    getFormatNumber(value, index) {
      if (Number(value) === 0) return '';

      switch (index) {
        case 'fingers_number':
          return Formatter.formatNumber(value, 0);
        case 'hands_number_avg':
          return Math.floor(value);

        default:
          return Formatter.formatNumber(value, 2);
      }
    },

    getValueData(arrayData, index, returnType) {
      const array = arrayData[index] ? arrayData[index] : [];

      if (index === 'ratio' || index === 'merma') {
        const sum = getSumOfValorFromArray(arrayData['sum_defects']);
        const sumNet = getSumOfValorFromArray(arrayData['net_weight_avg']);
        const count = arrayData['cluster'].length;

        return index === 'merma'
          ? Number((sum / sumNet) * 100)
          : Number((sumNet - sum) / (18.86 * count));
      }

      if (returnType === 1) {
        return (
          getSumOfValorFromArray(array) /
          array.filter((value) => value && Number(value) !== 0).length
        );
      }

      if (returnType === 2) {
        const max = Math.max(...array);
        return max;
      }

      if (returnType === 3) {
        const min = Math.min(...array);
        return min;
      }
    },
  },
};
</script>
